import { useMemo } from "react";
import { useSnapshot } from "valtio";
import { useProjectsQuery } from "@gql/sites-api/graphql";
import { siteStore } from "src/js/stores/site/store";
import { routedClient, LandTechEndpoints } from "react-migration/lib/persistence/apollo";
import { useSelectedProjectQuery } from "./useSelectedProjectQuery";

export function useProjectsDropdownList() {
  const { selectedProjectId } = useSnapshot(siteStore);
  const { list, ...listQueryState } = useListQuery();
  const { selectedProject, ...selectedProjectQueryState } = useSelectedProjectQuery();
  const error = listQueryState.error || selectedProjectQueryState.error;
  const loading = listQueryState.loading || selectedProjectQueryState.loading;

  const listSansSelectedProject = useMemo(
    () => list.filter((project) => project.id !== selectedProjectId),
    [list, selectedProjectId]
  );

  return {
    selected: selectedProject,
    list: listSansSelectedProject,
    error,
    loading,
  } as const;
}

function useListQuery() {
  const { data, ...queryState } = useProjectsQuery({
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
    /**
     * We want to first use the cache for speed, but we also want to want to hit
     * the network in case one of the projects has since been opened resulting
     * in a different order.
     */
    fetchPolicy: "cache-and-network",
  });

  return {
    list: data?.projects ?? [],
    ...queryState,
  };
}
